import {definitions} from './definitions/index.js';
import {zobjectUpdated} from './subpatch/operations.js';
import {hotReloadNode, quickRefresh} from "messaging/hotReload.js"
import {isNumber} from "utils/IsNumber.js";

export default superclass => class extends superclass  {
    get text() {
        return this._text;
    }
    
    set text(text) {
        this._text = text;

        // ex: "> 5" is a "greater than" function with args=[5]
        let tokens = text.split(" ").filter(
            x => x !== " " && x !== "");

        let name = tokens[0];

        if (!definitions[name]) {
            this.function = undefined;
            return;
        }

        let oldArgs = this.args;
        let nameChanged = this.name !== name;
        let oldName = this.name;

        let fn = definitions[name];
        let args = this.parseArgs(tokens.splice(1));

        // this.onNewArgs(args);
        let shouldDelete = this.onNewFunction(name, args);

        if (oldArgs === this.args) {
            this.previousArgs = [... this.args];
        }
        this.args = [... args];

        let lazyArgs = new Array(16).fill(undefined).map(
            (a, i) => () => this.args[i]);

        // Now we evaluate the function with these lazy arguments
        // When a message is processed, the function can look up
        // the current values of the arguments

        if (nameChanged) {
            this.dependencies = undefined;
            this.function = fn(this, ... lazyArgs);
            this.registerName(this.name, name);
        } else {
            // name did not change so args may have changed
            this.previousArgs = this.args;
        }

        if (shouldDelete) {
            this.deleteInlet("Input");
        }

        if (this.needsLoad && !this.sequencerEngine.isLoading) {
            this.onInputMessage(["start"]);
        }

        if (this.needsHotReload && !this.sequencerEngine.isLoading) {
            quickRefresh(this);
            // this.refresh();
        }

        this.subSequence.propagate(
            zobjectUpdated(this, text));
    }

    isValid() {
        return this.function !== undefined;
    }

    parseArgs(args) {
        let _args = [];
        for (let arg of args) {
            if (isNumber(arg)) {
                _args.push(parseFloat(arg));
            } else {
                _args.push(arg);
            }
        }
        return _args;
    }

    registerName(oldName, name) {
        let {nameToObjects} = this.sequencerEngine;
        if (!nameToObjects[name]) {
            nameToObjects[name] = [];
        }
        nameToObjects[name].push(this);

        if (nameToObjects[oldName]) {
            nameToObjects[oldName] = nameToObjects[oldName].filter(
                x => x !== this);
        }
    }
}
